import { z } from "zod";

const ONLY_NUMBERS_REGEX = /^\d+$/;
export const profileSchema = z.object({
    email: z
        .string()
        .min(1, "El correo es obligatorio")
        .email("Formato incorrecto"),

    phone: z
        .string()
        .min(1, "El teléfono es obligatorio")
        .regex(ONLY_NUMBERS_REGEX,'El teléfono debe contener números')
        .length(10,"El teléfono debe contener 10 caracteres"),
    
    curp: z.string().optional().refine((val) => !val || val.length === 18, {
        message: "La CURP debe tener exactamente 18 caracteres"
    })
});

const PASSWORD_REGEX =
  /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[^A-Za-z\d]).{8,}$/;


//para la actualizacion de la contraseña
export const passwordPasswordchema=z.object({
    currentPassword:z.string().min(1,'La contraseña actual es requerida'),
    newPassword:z.string().min(8,{message:"La nueva contraseña debe ser de almenos 8 caracteres"}).regex(
  PASSWORD_REGEX,''
 ) ,
    confirmPassword:z.string().min(8,{message:"La confirmación de la nueva contraseña debe ser de almenos 8 caracteres"}).regex(
  PASSWORD_REGEX,''
 
 ) ,
//   "La contraseña debe tener al menos 8 caracteres, una mayúscula, una minúscula, un número y un carácter especial."
})
.superRefine((data, ctx) => {

        // 1. Primero verificamos que la nueva sea diferente
        //    a la contraseña actual
        if (data.currentPassword === data.newPassword) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message:
                    "La contraseña actual y la nueva contraseña deben ser diferentes",
                path: ["newPassword"],
            });

            // No continuamos con la siguiente validación
            return;
        }

        // 2. Si pasó la validación anterior,
        //    verificamos la confirmación
        if (data.newPassword !== data.confirmPassword) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message:
                    "La nueva contraseña y su confirmación no coinciden",
                path: ["confirmPassword"],
            });
        }
    });